import { useDyteMeeting, useDyteSelector } from '@dytesdk/react-web-core';
export function useSimpleActiveSpeaker() {
    const { meeting } = useDyteMeeting();
    const lastActiveSpeaker = useDyteSelector((m) => m.participants.lastActiveSpeaker);
    return [meeting.participants.joined.get(lastActiveSpeaker)];
}
